import { makeApiActionCreatorV3 } from '@actions/utils';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';

import * as api from '../api/arbitrationEvidence';

const namespace = 'ARBITRATION_EVIDENCE';

export const FETCH_EVIDENCES_START = `${namespace}/FETCH_EVIDENCES_START`;
export const FETCH_EVIDENCES_SUCCESS = `${namespace}/FETCH_EVIDENCES_SUCCESS`;
export const FETCH_EVIDENCES_ERROR = `${namespace}/FETCH_EVIDENCES_ERROR`;

export const fetchEvidences = makeApiActionCreatorV3(
  api.fetchEvidences,
  FETCH_EVIDENCES_START,
  FETCH_EVIDENCES_SUCCESS,
  FETCH_EVIDENCES_ERROR,
);

export const ARBITRATION_UPLOAD_EVIDENCE = createRequestTypes(
  `${namespace}/ARBITRATION_UPLOAD_EVIDENCE`,
);

export const uploadEvidence = makeApiActionCreatorV3(
  api.uploadEvidence,
  ARBITRATION_UPLOAD_EVIDENCE[START],
  ARBITRATION_UPLOAD_EVIDENCE[SUCCESS],
  ARBITRATION_UPLOAD_EVIDENCE[ERROR],
);

export const ARBITRATION_INSERT_EVIDENCE = createRequestTypes(
  `${namespace}/ARBITRATION_INSERT_EVIDENCE`,
);

export const insertEvidence = makeApiActionCreatorV3(
  api.insertEvidence,
  ARBITRATION_INSERT_EVIDENCE[START],
  ARBITRATION_INSERT_EVIDENCE[SUCCESS],
  ARBITRATION_INSERT_EVIDENCE[ERROR],
);

export const ARBITRATION_DELETE_EVIDENCE = createRequestTypes(
  `${namespace}/ARBITRATION_DELETE_EVIDENCE`,
);

export const deleteEvidence = makeApiActionCreatorV3(
  api.deleteEvidence,
  ARBITRATION_DELETE_EVIDENCE[START],
  ARBITRATION_DELETE_EVIDENCE[SUCCESS],
  ARBITRATION_DELETE_EVIDENCE[ERROR],
);
